var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 47.5H12.5C11.1739 47.5 9.90215 46.9732 8.96447 46.0355C8.02678 45.0979 7.5 43.8261 7.5 42.5V17.5M7.5 17.5C7.5 16.1739 8.02678 14.9021 8.96447 13.9645C9.90215 13.0268 11.1739 12.5 12.5 12.5H47.5C48.8261 12.5 50.0979 13.0268 51.0355 13.9645C51.9732 14.9021 52.5 16.1739 52.5 17.5M7.5 17.5L30 32.5L52.5 17.5M52.5 17.5V32.5M37.5 47.5L42.5 52.5L52.5 42.5",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCheck);
export default __webpack_public_path__ + "static/media/mail-check.a6e9f4e4ff41118f6f67b728400df6e3.svg";
export { ForwardRef as ReactComponent };